import { useEffect, useState } from 'react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getCompanyLogoUrl } from 'src/utils/getCompanyLogoUrl';
import { cn } from 'src/lib/utils';

type Props = {
  name: string;
  logo?: string;
  size?: 'sm' | 'md' | 'lg';
  rounded?: 'lg' | 'md' | 'sm';
  className?: string;
  shouldFetchLogo?: boolean;
};

const sizeMap = {
  sm: 'size-6',
  md: 'size-8',
  lg: 'size-10',
};

const roundedMap = {
  lg: 'rounded-lg',
  md: 'rounded-md',
  sm: 'rounded-sm',
};

const OrganizationLogo = ({ logo, name, size = 'md', rounded = 'sm', className, shouldFetchLogo = true }: Props) => {
  const [logoUrl, setLogoUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    const fetchLogo = async () => {
      if (!logo) return;

      const fetchedLogo = shouldFetchLogo ? await getCompanyLogoUrl(logo) : logo;
      setLogoUrl(fetchedLogo);
    };

    fetchLogo();
  }, [logo, shouldFetchLogo]);

  return (
    <Avatar className={cn('border border-muted bg-muted', sizeMap[size], roundedMap[rounded], className)}>
      <AvatarImage src={logoUrl} />
      <AvatarFallback className="text-foreground uppercase text-lg">{name.charAt(0)}</AvatarFallback>
    </Avatar>
  );
};

export default OrganizationLogo;
